<template>
  <div>
    <b-modal
      centered
      title="Create Word"
      v-model="isOpen"
      id="modal-xl"
      size="xl"
      hide-footer
    >
      <b-card class="mt-1">
        <b-row>
          <b-col cols="3">
            <strong class="h6">Image</strong>
            <ui-component :component-data="word.image" class="border" />
          </b-col>
          <b-col cols="9">
            <b-col cols="12">
              <b-form-group label="Title" label-for="v-title">
                <b-input v-model="word.title" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Spelling" label-for="v-spelling">
                <b-input v-model="word.spelling" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Translation" label-for="v-subtitle">
                <ui-component :component-data="word.sub" class="border" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Description" label-for="v-description">
                <ui-component :component-data="word.description" class="border" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Audio" label-for="v-audio">
                <ui-component :component-data="word.audio" class="border" />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Flip" label-for="v-flip">
                <div class="d-flex">
                  <b-form-checkbox
                    class="custom-control-primary"
                    name="is_publish_checkbox"
                    switch
                    v-model="word.flip"
                  >
                    <span class="switch-icon-left">
                      <feather-icon icon="CheckCircleIcon" />
                    </span>
                    <span class="switch-icon-right">
                      <feather-icon icon="XCircleIcon" />
                    </span>
                  </b-form-checkbox>
                  <strong>{{ word.flip ? "Yes" : "No" }}</strong>
                </div>
              </b-form-group>
            </b-col>
          </b-col>
        </b-row>
      </b-card>
      <div class="d-flex justify-content-between my-2">
        <b-button variant="danger" @click="cancel">Cancel</b-button>
        <b-button type="submit" variant="primary" @click="save">Save</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import defaultObject from './defaultObject'
export default {
  data() {
    return {
      word: JSON.parse(JSON.stringify(defaultObject)),
      isOpen: false,
      isUpdate: false,
      wordIndex: null
    };
  },
  methods: {
    openCreateModal() {
      this.word = JSON.parse(JSON.stringify(defaultObject));
      this.isOpen = true;
      this.isUpdate = false;
    },
    openUpdateModal(word, index){
      this.word = word;
      this.wordIndex = index;
      this.isUpdate = true;
      this.isOpen = true;
    },
    save(){
      this.isOpen = true;
      if(!this.isUpdate){
        this.$emit("addWord", this.word)
      }
      else{
        this.$emit("updateWord",{ word:this.word, index: this.wordIndex})
      }
      this.wordIndex = null;
      this.isOpen = false;
    },
    cancel(){
      this.wordIndex = null;
      this.isUpdate = false,
      this.isOpen = false;
    }
  },
};
</script>
